import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type UrlResponse = {
  url: string;
};

export const useAdminFileLinkMutation = (companyId: string) => {
  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<{ data: UrlResponse }, Error, number>({
    mutationFn: fileId =>
      api.post<UrlResponse>(`admin/companies/${companyId}/files/${fileId}/file-links`, {}),
  });

  const createLink = async (fileId: number): Promise<UrlResponse> => {
    const result = await mutateAsync(fileId);
    return result.data;
  };

  return {
    createLink,
    isLoading,
    isError,
  };
};
